import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import React from "react";
import { connect } from "react-redux";
import { logoutUser } from "../actions/authActions";

///const mapStateToProps = state => ({ authReducer: state.authReducer });
const useStyles = makeStyles((theme) => ({
	button: {
		margin: theme.spacing(1),
	},
}));

class Logout extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			username: "",
			password: "",
		};

		this.handleLogout = this.handleLogout.bind(this);
	}

	handleLogout = (event) => {
		event.preventDefault();
		this.props.logoutUser();
		console.log("handleLogout this.state=", this.state);
	};

	render() {
		return (
			<IconButton onClick={this.handleLogout}>
				<ExitToAppIcon />
			</IconButton>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	logoutUser: () => dispatch(logoutUser()),
});

export default connect(null, mapDispatchToProps)(Logout);
